var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 46.5742C56.274 46.5742 52.95 48.7732 50.16 50.9992C46.56 53.8612 43.419 57.2812 41.022 61.2022C39.225 64.1422 37.5 67.7062 37.5 70.5742M37.5 70.5742C37.5 67.7062 35.775 64.1392 33.978 61.2022C31.578 57.2812 28.437 53.8612 24.843 50.9992C22.05 48.7732 18.72 46.5742 16.5 46.5742M37.5 70.5742L37.5 2.99951",
    stroke: "#AEBFBF",
    strokeWidth: 2.57142
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.f8c48c02f9d22f3aacd10c9a0e5a3095.svg";
export { ForwardRef as ReactComponent };